// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7e7819c0","404":"4e1443ea","498":"f57af8de"}[chunkId] + ".chunk.js";
};